function dimensions(){

    function init(){

        width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        scrollW = document.documentElement.scrollWidth;

        height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        scrollH = document.documentElement.scrollHeight;

        deviceW = screen.width;
        deviceAW = screen.availWidth;

        deviceH = screen.height;
        deviceAH = screen.availHeight;

        colorD = screen.colorDepth;
        pixelD = screen.pixelDepth;

        // math dimensions
    
            // width relative to browser
            $('.js-fw').css({'width': ''+width+''});
            $('.js-95w').width(width * .95);
            $('.js-90w').width(width * .9);
            $('.js-85w').width(width * .85);
            $('.js-80w').width(width * .8);
            $('.js-75w').width(width * .75);
            $('.js-70w').width(width * .7);
            $('.js-65w').width(width * .65);
            $('.js-60w').width(width * .6);
            $('.js-55w').width(width * .55);
            $('.js-50w').width(width/2);
            $('.js-45w').width(width * .45);
            $('.js-40w').width(width * .4);
            $('.js-35w').width(width * .35);
            $('.js-33w').width(width/3);
            $('.js-30w').width(width * .3);
            $('.js-25w').width(width/4);
            $('.js-20w').width(width/5);
            $('.js-15w').width(width * .15);
            $('.js-10w').width(width/10);
            $('.js-5w').width(width/20);
            $('.js-1w').width(width/100);

            // height relative to browser
            $('.js-fh').css({'height': ''+height+''});
            $('.js-95h').height(height * .95);
            $('.js-90h').height(height * .9);
            $('.js-85h').height(height * .85);
            $('.js-80h').height(height * .8);
            $('.js-75h').height(height * .75);
            $('.js-70h').height(height * .7);
            $('.js-65h').height(height * .65);
            $('.js-60h').height(height * .6);
            $('.js-55h').height(height * .55);
            $('.js-50h').height(height/2);
            $('.js-45h').height(height * .45);
            $('.js-40h').height(height * .4);
            $('.js-35h').height(height * .35);
            $('.js-33h').height(height/3);
            $('.js-30h').height(height * .3);
            $('.js-25h').height(height/4);
            $('.js-20h').height(height/5);
            $('.js-15h').height(height * .15);
            $('.js-10h').height(height/10);
            $('.js-5h').height(height/20);
            $('.js-1h').height(height/100);
            


        $('[data-grid-animation="expand"] [class*="aspect-"]').each(function(){

            var _this = $(this),
                classes = _this.attr("class").split(/\s+/),
                found = classes.findIndex(element => element.includes("aspect-"));

                if(found > -1){

                    var switch_class = classes[0];

                    switch (switch_class) {

                        // 1x2
                        case switch_class.match(/1x2/i)?.input:
                            height_val = (_this.outerWidth() * 2)+'px';
                        break;

                        // 1x3
                        case switch_class.match(/1x3/i)?.input:
                            height_val = (_this.outerWidth() * 3)+'px';
                        break;

                        // 1x4
                        case switch_class.match(/1x4/i)?.input:
                            height_val = (_this.outerWidth() * 4)+'px';
                        break;

                        // 1x5
                        case switch_class.match(/1x5/i)?.input:
                            height_val = (_this.outerWidth() * 5)+'px';
                        break;

                        // 1x6
                        case switch_class.match(/1x6/i)?.input:
                            height_val = (_this.outerWidth() * 6)+'px';
                        break;

                        // 2x5
                        case switch_class.match(/2x5/i)?.input:
                            height_val = (_this.outerWidth() * 5/2)+'px';
                        break;

                        // 3x1
                        case switch_class.match(/3x1/i)?.input:
                            height_val = (_this.outerWidth()/3)+'px';
                        break;

                        // landscape | 3x2
                        case switch_class.match(/landscape|3x2/i)?.input:
                            height_val = (_this.outerWidth() * 2/3)+'px';
                        break;

                        // 3x4
                        case switch_class.match(/3x4/i)?.input:
                            height_val = (_this.outerWidth() * 4/3)+'px';
                        break;

                        // 3x5
                        case switch_class.match(/3x5/i)?.input:
                            height_val = (_this.outerWidth() * 5/3)+'px';
                        break;

                        // 4x1
                        case switch_class.match(/4x1/i)?.input:
                            height_val = (_this.outerWidth()/4)+'px';
                        break;

                        // 4x3 | SD
                        case switch_class.match(/4x3|sd/i)?.input:
                            height_val = (_this.outerWidth() * 3/4)+'px';
                        break;

                        // 5x1
                        case switch_class.match(/5x1/i)?.input:
                            height_val = (_this.outerWidth()/5)+'px';
                        break;

                        // 5x2
                        case switch_class.match(/5x2/i)?.input:
                            height_val = (_this.outerWidth() * 2/5)+'px';
                        break;

                        // 5x3
                        case switch_class.match(/5x3/i)?.input:
                            height_val = (_this.outerWidth() * 3/5)+'px';
                        break;

                        // 5x4
                        case switch_class.match(/5x4/i)?.input:
                            height_val = (_this.outerWidth() * 4/5)+'px';
                        break;

                        // 6x1
                        case switch_class.match(/6x1/i)?.input:
                            height_val = (_this.outerWidth()/6)+'px';
                        break;

                        // 6x2
                        case switch_class.match(/6x2/i)?.input:
                            height_val = (_this.outerWidth() * 1/3)+'px';
                        break;

                        // 6x5
                        case switch_class.match(/6x5/i)?.input:
                            height_val = (_this.outerWidth() * 5/6)+'px';
                        break;

                        // 10x13
                        case switch_class.match(/10x13/i)?.input:
                            height_val = (_this.outerWidth() * 13/10)+'px';
                        break;

                        // 16x9 | HD
                        case switch_class.match(/16x9|hd/i)?.input:
                            height_val = (_this.outerWidth() * 9/16)+'px';
                        break;

                        // square 
                        case switch_class.match(/square/i)?.input:
                            height_val = _this.outerWidth()+'px';
                        break;

                        // portrait | 2x3
                        case switch_class.match(/portrait|2x3/i)?.input:
                            height_val = (_this.outerWidth() * 3/2)+'px';
                        break;

                        // rectangle | 2x1
                        case switch_class.match(/rectangle|2x1/i)?.input:
                            height_val = (_this.outerWidth() * 2/3)+'px';
                        break;

                        // default
                        default:
                        console.log("Didn't match");
                        break;
                    }

                        _this.css({'height': height_val});
                        _this.closest('.grid-item').css({'height': height_val});

                }

        });

    }

    init();


        // window.resize
    $(window).resize(function() {
        init();
    });
    // window.resize

}


/*! Transition Callback !*/
function whichTransitionEvent(){
  var t,
      el = document.createElement("fakeelement");

  var transitions = {
    "transition"      : "transitionend",
    "OTransition"     : "oTransitionEnd",
    "MozTransition"   : "transitionend",
    "WebkitTransition": "webkitTransitionEnd"
  }

  for (t in transitions){
    if (el.style[t] !== undefined){

      // console.log(transitions[t], el);
      return transitions[t];
    }
  }
}

var transitionEvent = whichTransitionEvent();
/*! Transition Callback !*/



/*! Animation Callback */
function whichAnimationEvent(){
  var t,
      el = document.createElement("fakeelement");

  var animations = {
    "animation"      : "animationend",
    "OAnimation"     : "oAnimationEnd",
    "MozAnimation"   : "animationend",
    "WebkitAnimation": "webkitAnimationEnd"
  }

  for (t in animations){
    if (el.style[t] !== undefined){
      return animations[t];
    }
  }
}

var AnimationEvent = whichAnimationEvent();
/*! Animation Callback !*/


// Import jQuery
// var $ = require( "jquery" );

var $ = jQuery.noConflict();

;(function ($) {
    var oAddClass = $.fn.addClass;
    $.fn.addClass = function () {
        for (var i in arguments) {
            var arg = arguments[i];
            if ( !! (arg && arg.constructor && arg.call && arg.apply)) {
                setTimeout(arg.bind(this));
                delete arguments[i];
            }
        }
        return oAddClass.apply(this, arguments);
    }

})(jQuery);


function buttonColor(){

    function init(){


        if(width <= 1400){

            if( $('.section-hero').hasClass('config-one') ){
                $('.section-hero .wp-block-button').addClass('-orange-background');
            }

        }else{

            if( $('.section-hero').hasClass('config-one') ){
                $('.section-hero .wp-block-button').removeClass('-orange-background');
            }

        }

    }


    init();

    $(window).resize(function() {

        init();

    });

}

/*! external links */
$('body a').each(function() {

    if ($(this).attr('href') !== undefined){

       var a = new RegExp('/' + window.location.host + '/');
       if (!a.test(this.href)) {
           $(this).attr("target","_blank").addClass('external');
       }

    }

});
/*!  external links */


// iframe configuration
function iframeconfiguration(details){

    //if details is an object
    if (typeof details == 'object'){

        var el = details.element;
                focus = el;

    }
    //if details is an object

    //if details is NOT an object
    else{

        var focus = $('iframe');

    }
    //if details is NOT an object


    // if target element

    focus.each(function() {

      var _this = $(this);

      // youtube or vimeo
      if ( _this.attr('src') && (_this.attr('src').match(/youtube.com/ig) || _this.attr('src').match(/vimeo.com/ig)) ){

          if (_this.attr('src').match(/youtube.com/ig)){
              var videosrc = 'video-youtube';
          }else if (_this.attr('src').match(/vimeo.com/ig)){
              var videosrc = 'video-vimeo';
          }

          // not adaptive | wp embed | lazyframe
          if (!_this.parent().hasClass('adaptive') && !_this.parent().hasClass('lazyframe') && !_this.closest('.content-section').hasClass('full-background-figure') ){

              if (_this.attr('width') && _this.attr('height')){

                  var width = _this.attr('width'),
                      height = _this.attr('height'),
                      ratio = width/height,
                      inverseratio = height/width;
              }

              _this.removeAttr('width').removeAttr('height').wrap( '<div class="media-constrain '+videosrc+'"><div class="media-container"></div></div>');

              // _this.removeAttr('width').removeAttr('height').css({'height': '100%', 'left': 0, 'position': 'absolute', 'top': 0,  'width': '100%'});
              // _this.wrap( '<div class="video-constrain"><div class="youtube-container"></div></div>');
              // _this.closest('.youtube-container').css({'height': 0, 'padding-bottom': '54%', 'padding-top': '30px', 'position': 'relative',  'overflow': 'hidden'});

          }
          // not adaptive | wp embed | lazyframe


          // if adaptive
          else{
            var controls = new Array(),
                    embed = _this.attr('src').split('?')[0],
                    embed_array = embed.split('/'),
                    directives = _this.attr('src').split('?')[1],
                    directives_array = directives.replaceAll(";", "").split('&');

                    directives_array.forEach(function(currentValue, index, arr){

                        var control = currentValue.split('=');

                        controls[''+control[0]+''] = control[1];

                    });


              if(_this.parent().attr('data-media')){

                  var controls = JSON.parse(''+_this.parent().attr('data-media')+''),
                      autoplay = controls.autoplay,
                      loop = controls.loop,
                      directives = "";

              }else{

                var autoplay = controls.autoplay,
                    loop = controls.loop,
                    directives = "";

              }


              // if youtube
              if (_this.attr('src').match(/youtube.com/ig)){

                    var index = embed_array.indexOf('embed'),
                            url = 'https://www.youtube.com/iframe_api',
                      tag = document.createElement('script'),
                      firstScriptTag = document.getElementsByTagName('script')[0],
                      naturalHeight = _this[0].naturalHeight,
                      naturalWidth = _this[0].naturalWidth,
                      startplay = (autoplay) ? 0 : 1,
                      player;

                      tag.src = url;

                  if(index >= 0 && index < embed_array.length - 1)
                                          var vidid = embed_array[index + 1],
                                                    iframeid = 'idgen-iframe-'+vidid+'';


                  if(!isScriptLoaded(url)){
                      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                  }

                  // if(_this.prev().length < 1){

                    if(!_this.attr('id')){
                            _this.attr('id', iframeid);

                    }

                        var iframeid = _this.attr('id');
                          

                      $.when( 

                          $('<div id="'+iframeid+'"></div>').insertBefore(_this),
                          fullscreen('#'+iframeid+''),
                          // $('#'+iframeid+'').attr('height', naturalHeight).attr('width', naturalWidth),

                      ).then(function() {

                          //create the YouTube Player
                          window.onYouTubeIframeAPIReady = function(){

                              player = new YT.Player(''+iframeid+'', {
                                      videoId: ''+vidid+'',
                                      playerVars: {
                                          end: 0, 
                                          autoplay: startplay,

                                          // for playlist looping
                                              // playlist: ''+vidid+'', 
                                              // loop: 0, 

                                          controls: 0, 
                                          showinfo: 0, 
                                          modestbranding: 1, 
                                          fs: 0, 
                                          cc_load_policty: 0, 
                                          iv_load_policy: 3, 
                                          autohide: 0,
                                          origin: window.location.href,
                                            widget_referrer: window.location.href
                                      }, 
                                       events: {

                                          // 'onReady': onPlayerReady,

                                          onReady: function(event) {
                                              if (autoplay) {
                                                  event.target.mute();
                                                  event.target.playVideo();
                                              }
                                                  _this.remove();
                                          },

                                          // to loop single video without reloading
                                          onStateChange: function(event) {
                                              if ((event.data === YT.PlayerState.ENDED) && (loop)) {
                                                  event.target.mute();
                                                  event.target.playVideo();
                                              }
                                          }
                                          // to loop single video without reloading

                                      }

                                  }
                              );
                          }
                          // create the YouTube Player

                          // YouTube Player ready
                          // function onPlayerReady(event) {
                          //     event.target.mute();
                          //     event.target.playVideo();
                          // }
                          // YouTube Player ready
                        
                      });


                  // }

              }
              // if youtube

              // if vimeo
              else if (_this.attr('src').match(/vimeo/ig)){

                  var src = _this.attr('src');

                  if(autoplay){

                      directives += 'background=1';

                  }

                  if (src.indexOf('?') > -1) {
                      var src = src.split('?'),
                          src = src[0];
                  }

                  function checkIfVideoExists(url, callback){
                      $.ajax({
                          type:'GET',
                          url: 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(url),
                          dataType: 'json',
                          complete: function(xhr) {
                              callback(xhr);
                              // console.log('xhr', xhr);
                          } 
                      });
                  }

                  checkIfVideoExists(''+src+'', function(xhr){

                      // if video exists
                      if(xhr.status == 200){

                          var video = $(''+xhr.responseJSON.html+''),
                              videosrc = video.attr('src');

                          if (videosrc.indexOf('?') > -1) {
                              video[0].src += "&"+directives+"";
                          }else{
                              video[0].src += "?"+directives+"";
                          }

                          if(video.attr('id')){
                              var target = video.attr('id');
                          }else{
                              var id = idCreate(randomNum(20, 70), '12345abcdefghijklm67890nopqrstuvwxyz'),
                                  target = "idgen-iframe-vimeo"+id;
                                  video.attr("id", target);
                          }

                          $.when( 

                              video.insertBefore(_this),
                              Qfx.adaptive({'element': ''+target+''})
                              // Qfx.adaptive({'element': ''+target+'', 'position': ["right", "bottom"]})

                          ).then(function() {

                              if(video.next('iframe')){
                                  video.next('iframe').remove();
                              }
                            
                          })

                          


                      }
                      // if video exists

                      // if video does not exist
                      else if(xhr.status == 404){
                          console.error('The vimeo video:', src, 'does not exist. Try another video'); // 404 - Not found
                      }
                      // if video does not exist
                      
                  });

              }
              // if vimeo

          }
          // if adaptive

      }
      // youtube or vimeo

      // google maps
      if ( _this.attr('src') && _this.attr('src').match(/google.com\/maps\//ig) ){

          _this.removeAttr('width').removeAttr('height').wrap('<div class="media-constrain map-google"><div class="media-container"></div></div>');

      }
      // google maps

      $('#'+iframeid+'').addClass('iframe-api-config');


    });


}
// iframe configuration


/*! resize !*/

function resize() {

    function init(){

        var clearance = $('header#site-header').outerHeight();

        $('.page-hero').css({'padding-top': clearance+'px'});

        $('.min-height-basis-calc').each(function() {

            var _this = $(this),
                basis = _this.find('.min-height-basis'),
                minH = basis.outerHeight();

            _this.css({'min-height': minH+'px'});

        });
        
    }

    setTimeout(init,100);

    $( window ).resize(function() {
        setTimeout(init,100);
    });
    
}
/*! resize !*/


(function($) {

    jQuery(document).ready(function() {

        // details

        const details = document.querySelectorAll('details');

        details.forEach( (detail, i) => {
          
            const siblings = detail.querySelectorAll('summary ~ *');
            const wrapper = document.createElement('div');
            wrapper.classList.add('content');

            siblings.forEach(sibling => {

                // Insert the wrapper before the first sibling
                sibling.parentNode.insertBefore(wrapper, sibling);

                // Move the sibling into the wrapper
                wrapper.appendChild(sibling);

            });

        });

        

        class Accordion {
          constructor(el) {
            // Store the <details> element
            this.el = el;
            // Store the <summary> element
            this.summary = el.querySelector('summary');
            // Store the <div class="content"> element
            this.content = el.querySelector('.content');

            // Store the animation object (so we can cancel it if needed)
            this.animation = null;
            // Store if the element is closing
            this.isClosing = false;
            // Store if the element is expanding
            this.isExpanding = false;
            // Detect user clicks on the summary element
            this.summary.addEventListener('click', (e) => this.onClick(e));
          }

          onClick(e) {
            // Stop default behaviour from the browser
            e.preventDefault();
            // Add an overflow on the <details> to avoid content overflowing
            this.el.style.overflow = 'hidden';
            // Check if the element is being closed or is already closed
            if (this.isClosing || !this.el.open) {
              this.open();
            // Check if the element is being openned or is already open
            } else if (this.isExpanding || this.el.open) {
              this.shrink();
            }
          }

          shrink() {
            // Set the element as "being closed"
            this.isClosing = true;
            
            // Store the current height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the height of the summary
            const endHeight = `${this.summary.offsetHeight}px`;
            
            // If there is already an animation running
            if (this.animation) {
              // Cancel the current animation
              this.animation.cancel();
            }
            
            // Start a WAAPI animation
            this.animation = this.el.animate({
              // Set the keyframes from the startHeight to endHeight
              height: [startHeight, endHeight]
            }, {
              duration: 400,
              easing: 'ease-out'
            });
            
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(false);
            // If the animation is cancelled, isClosing variable is set to false
            this.animation.oncancel = () => this.isClosing = false;
          }

          open() {
            // Apply a fixed height on the element
            this.el.style.height = `${this.el.offsetHeight}px`;
            // Force the [open] attribute on the details element
            this.el.open = true;
            // Wait for the next frame to call the expand function
            window.requestAnimationFrame(() => this.expand());
          }

          expand() {
            // Set the element as "being expanding"
            this.isExpanding = true;
            // Get the current fixed height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the open height of the element (summary height + content height)
            const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
            
            // If there is already an animation running
            if (this.animation) {
              // Cancel the current animation
              this.animation.cancel();
            }
            
            // Start a WAAPI animation
            this.animation = this.el.animate({
              // Set the keyframes from the startHeight to endHeight
              height: [startHeight, endHeight]
            }, {
              duration: 400,
              easing: 'ease-out'
            });
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(true);
            // If the animation is cancelled, isExpanding variable is set to false
            this.animation.oncancel = () => this.isExpanding = false;
          }

          onAnimationFinish(open) {
            // Set the open attribute based on the parameter
            this.el.open = open;
            // Clear the stored animation
            this.animation = null;
            // Reset isClosing & isExpanding
            this.isClosing = false;
            this.isExpanding = false;
            // Remove the overflow hidden and the fixed height
            this.el.style.height = this.el.style.overflow = '';
          }
        }

        document.querySelectorAll('details').forEach((el) => {
          new Accordion(el);
        });

        // details


        dimensions();
        buttonColor();
        iframeconfiguration();
        resize();

        var allHeadlineElements = jQuery('.site-hero h1 a, #content h1');
        var allHeadlineElementsCount = allHeadlineElements.length;

        for (var k = 0; k < allHeadlineElementsCount; k++) {
            var allHeadlineOriginal = allHeadlineElements[k];
            var allHeadlineNew = boldTitleHalf(allHeadlineOriginal);
            allHeadlineElements[k].innerHTML = allHeadlineNew;
        }

        // SCROLLING INVIEW
        $('#page > .content-section').each(function () {
          var self = this;
          /* eslint-disable*/
          var inview = new Waypoint.Inview({
          /* eslint-enable*/
            element: this,
            enter: function(direction) {

            var _this = $(self);

                /*! animation */
                if(_this.is('.animation')){

                    /*!  hero */
                    if(_this.is('.section-hero')) {

                        if(!_this.hasClass('visible')){

                            var html = $('.hero-text h1', _this).html();

                                // if(html.indexOf('<br>') !== -1){

                                if(html.includes('<br>')){

                                    var html_array = html.split('<br>'),
                                        html_lines = [];

                                    html_array.forEach((element, i) => {

                                        element = element.replace(/([A-Za-z0-9.’?'<>/]+)(?![^<]*>)/gi, '<span class="word">$1</span>')

                                        html_lines.push('<span class="line-'+i+'">'+element+'</span>');

                                    });

                                    var words = html_lines.join('');

                                }else{

                                    var words = html.replace(/([A-Za-z0-9.’?'<>/]+)(?![^<]*>)/gi, '<span class="word">$1</span>');
                                      
                                }


                                

                                $('.hero-text h1', _this).addClass('typography').html(words);

                            // config one | two | three
                            if(_this.is('.config-one') || _this.is('.config-two') || _this.is('.config-three')) {

                                var count = $('.hero-text h1 .word', _this).length;

                                $('.hero-text h1', _this).css({'opacity': 1});

                                $('.hero-text h1 .word', _this).each(function(i){

                                    var _word = $(this);

                                    _word.stop().delay(i * 1000).animate({'opacity': 1}, 200, function(){

                                        if (!--count) 

                                            showCircles(),
                                            showContent(), 
                                            showAccents();

                                    });

                                });

                                function showCircles(){

                                    _this.addClass('reveal-circle');

                                    if(width <= 1400){
                                        
                                        _this.addClass('animation-done');

                                    }else{

                                        var _target = ( $('.section-hero').hasClass('config-one') || $('.section-hero').hasClass('config-two') ) ? $('.circle-two') : $('.circle-three');

                                        $('.circle-two').one(transitionEvent, function(event) {
                                            _this.addClass('animation-done');
                                        });

                                    }

                                }

                                function showContent(){
                                    _this.delay(500).addClass('reveal-content');
                                }

                                function showAccents(){

                                    _this.delay(1000).addClass('reveal-accents');
                                }

                            }
                            // config one | two | three

                            $(self).addClass('visible active').siblings().removeClass('active');
                        }

                    }

                }


            },
            exited: function(direction) {
            },
          })
        });
        // SCROLLING INVIEW




    });

})(jQuery);

var eventFired = 0;

if ($(window).width() > 992) {

    $("#site-menu").removeClass("toggled");

}

$(window).on('resize', function() {

    if ($(window).width() > 992) {
        $("#site-menu").removeClass("toggled");
    }

});

function boldTitleHalf(element) {

    string = element.innerHTML;

    if (string.includes('<strong>') ||
        string.includes('<span>')) {
        return string;
    } else if (string.includes('<a ')) {
        string = element.innerHTML;
    } else {
        string = element.innerText;
    }



    //Work in progress
    //TODO preserver tags around innerText to preserve color and such. Right now it only really works with links around the entire headline
    if (string.includes("<")) {
        //console.log('The following tag contains something:');
        //console.log(string);
        var startTag = 0;
        var t = 0;
        var tags = [];
        for (var s = 0; s < string.length; s++) {
            if (string[s] == "<") {
                startTag = 1;

                tags.push({
                    location: s,
                    value: string[s],
                });
            }

            if (startTag && string[s] != "<") {
                tags[t].value += string[s];
            }

            if (string[s] == ">") {
                startTag = 0;
                t++;
            }
        }
    }
    //console.log(tags); 

    string = element.innerText;

    var theWords = string.split(" ");

    var wordCount = theWords.length;

    var boldSplit = wordCount / 2;
    boldSplit = Math.round(boldSplit);

    var newValue = "";

    for (var i = 0; i <= wordCount; i++) {

        //Only run if there is more than one word
        if (wordCount > 1) {
            //Skip first word if it is a number
            var checkNum = parseInt(theWords[0], 10);
            if (i == 0 && !isNaN(checkNum)) {
                //i++;
                //newValue = newValue + theWords[i];
                boldSplit = boldSplit - 1;
            }
            //Add space before next words
            if (i != 0 || i == wordCount) {
                newValue = newValue + " ";
            }

            //Begin bold part of title
            if (wordCount - i == boldSplit) {
                newValue = newValue + "<span class='alt'>";
                var setBold = true;
            }

            //Add words to newValue
            if (theWords[i]) {
                newValue = newValue + theWords[i];
            }

            //Close strong if we are at the end
            if (setBold && i == wordCount) {
                newValue = newValue + "</span>";
            }
        } else {
            newValue = string;
        }
    }

    if (typeof tags != 'undefined') {
        if (tags.length > 1 && tags[0].value.includes('<a ')) {
            var tmpValue = tags[0].value;
            tmpValue += newValue;
            tmpValue += tags[1].value;
            newValue = tmpValue;
        }
    }

    return newValue;
}

// FULLWIDTH SPAN

jQuery(document).ready(function() {	

    jQuery('<div class="full-width-span-pusher">&nbsp;</div>').insertAfter('.full-width-span');
    jQuery(window).on('resize',function() {
        var imgHeight = jQuery('.full-width-span').height();
        // console.log(imgHeight);
        jQuery('.full-width-span-pusher').css('margin-top', imgHeight);
    }).trigger('resize');

    jQuery('<div class="fwsp">&nbsp;</div>').insertAfter('.fws');
    jQuery(window).on('resize',function() {
        var imgHeightForm = jQuery('.fws').height();
        // console.log(imgHeightForm);
        jQuery('.fwsp').css('margin-top', imgHeightForm);
    }).trigger('resize');

});

// COUNTING NUMBERS

function counterAnimationHandler() {
  const counters = document.querySelectorAll(".count");
  counters.forEach((counter) => {
    counter.innerText = "0"; //set default counter value
    counter.dataset.count = 0;
    const updateCounter = () => {
      const target = +counter.getAttribute("data-target"); //define increase couter to it's data-target
      const count = +counter.dataset.count; //define increase couter on innerText

      const increment = target / 600; // define increment as counter increase value / speed

      if (count < target) {
        const newCount = Math.ceil(count + increment);
        counter.dataset.count = newCount;
        counter.innerText = numberWithCommas(newCount);
        setTimeout(updateCounter, 1);
      } else {
        counter.innerText = numberWithCommas(target); //if default value is bigger that date-target, show data-target
      }
    };

    updateCounter(); //call the function event
  });

  function numberWithCommas(x) {
    var parts = x.toString().split(".");
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

// counterAnimationHandler();
// window.onload = counterAnimationHandler;

// Fade In Only
$(document).ready(function() {
    var $ = jQuery.noConflict();
    $('.faderIn').css('opacity', 0);
    //set a waypoint for all the page parts on the page
    var ppWaypoint = $('.faderIn').waypoint(function(direction) {
        //check the direction
        if (direction == 'down') {
            $(this.element).addClass('animated fadeIn');
            counterAnimationHandler();
        } else {
            $(this.element).removeClass('animated fadeIn');
            $('.faderIn').css('opacity', 1);
            this.destroy();
        }
    }, {
        //Set the offset
        offset: '90%'
    });
});

// Hero editable copy animation

    // Homepage
    // ==================

    // const tlName = gsap.timeline({repeat:0}), split1 = new SplitText(".name", { type: "words, words" }), words1 = split1.words;
    // tlName.from(words1, { delay: 3.6, opacity: 0, duration: .1, stagger: .1 });
    // tlName.to(words1, { duration: 1, opacity: 1, stagger: 0.1, ease: "power4.inOut" });

    // const tlLook = gsap.timeline({repeat:0}), split2 = new SplitText(".look", { type: "words, words" }), words2 = split2.words;
    // tlLook.from(words2, { delay: 4.2, opacity: 0, duration: .1, stagger: .1 });
    // tlLook.to(words2, { duration: 1, opacity: 1, stagger: 0.1, ease: "power4.inOut" });

    // const tlFormerly = gsap.timeline({repeat:0}), split3 = new SplitText(".formerly", { type: "chars, words" }), chars3 = split3.chars;
    // tlFormerly.from(chars3, { delay: 5, opacity: 0, duration: .1, stagger: .015 });
    // tlFormerly.to(chars3, { duration: .2, opacity: 1, stagger: 0.05, ease: "power4.inOut" });

    // const tlDate = gsap.timeline({repeat:0}), split4 = new SplitText(".date", { type: "chars, words" }), chars4 = split4.chars;
    // tlDate.from(chars4, { delay: 2.2, opacity: 0, duration: .1, stagger: .015 });
    // tlDate.to(chars4, { duration: .2, opacity: 1, stagger: 0.05, ease: "power4.inOut" });

    // const tlLocation = gsap.timeline({repeat:0}), split5 = new SplitText(".location", { type: "chars, words" }), chars5 = split5.chars;
    // tlLocation.from(chars5, { delay: 2.4, opacity: 0, duration: .1, stagger: .015 });
    // tlLocation.to(chars5, { duration: .2, opacity: 1, stagger: 0.05, ease: "power4.inOut" });

    // Internal
    // ==================

    // const tlTitle = gsap.timeline({repeat:0}), split6 = new SplitText(".page-hero-content h2", { type: "chars, words" }), chars6 = split6.chars;
    // tlTitle.from(chars6, { delay: 1, opacity: 0, duration: 1, stagger: .015 });
    // tlTitle.to(chars6, { duration: 3, opacity: 1, left: 0, stagger: 0.25, ease: "power4.inOut" });

// END Hero editable copy animation




